/**
 * SHER-803 - must stay the FIRST import of src/index.jsx (pinned by bootAcceptFragment.test.ts).
 * Removes an invitation link's secret from the address bar before Sentry Replay, mixpanel or the
 * telemetry module can record the URL. See captureAcceptFragmentAtBoot.
 */
import { captureAcceptFragmentAtBoot } from './utils/invitationLink';

captureAcceptFragmentAtBoot(window);
